(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article-body"]) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-mm-article-content]');
    if (!root) return;
    root.querySelectorAll('meta, title, base, link, head').forEach(function (el) {
      el.remove();
    });
    root.querySelectorAll('body').forEach(function (el) {
      var parent = el.parentNode;
      while (el.firstChild) parent.insertBefore(el.firstChild, el);
      parent.removeChild(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bubbas-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start() {
      var sections = document.querySelectorAll('[data-bb-hero]');
      if (!sections.length) return;

      /* Decide whether to auto-rotate. On heavy connections (slow network or
         Save-Data) or for reduced-motion users we keep a single static image
         and never fetch the other variant images. Otherwise we rotate. */
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      var heavy = false;
      if (conn) {
        if (conn.saveData) heavy = true;
        var et = conn.effectiveType || '';
        if (et === 'slow-2g' || et === '2g' || et === '3g') heavy = true;
      }
      var shouldRotate = !reduceMotion && !heavy;

      sections.forEach(function (root) {
        var delay = parseInt(root.getAttribute('data-bb-delay'), 10) || 4000;
        var fxMs = parseInt(root.getAttribute('data-bb-fx-ms'), 10) || 350;
        var isSlide = root.classList.contains('bb-hero--fx-slide');
        var carousels = root.querySelectorAll('[data-bb-carousel]');
        carousels.forEach(function (car) {
          var slides = car.querySelectorAll('.bb-hero__slide');
          if (!slides.length) return;
          /* Too heavy to rotate (or only one image): keep the first slide. */
          if (!shouldRotate || slides.length < 2) return;

          var i = 0;
          setInterval(function () {
            /* Skip the carousel that's hidden at the current breakpoint. */
            if (car.offsetParent === null) return;
            var next = (i + 1) % slides.length;
            var current = slides[i];
            var nextSlide = slides[next];
            /* Lazily load each variant image right before it's shown. */
            if (!nextSlide.style.backgroundImage) {
              var bg = nextSlide.getAttribute('data-bg');
              if (bg) nextSlide.style.backgroundImage = 'url(' + bg + ')';
            }
            current.classList.remove('is-active');
            nextSlide.classList.add('is-active');

            if (isSlide) {
              /* Push the outgoing slide off to the left, then snap it back to
                 the waiting position (off-screen right) without animating so
                 it's ready to slide in again on its next turn. */
              current.classList.add('is-leaving');
              setTimeout(function () {
                current.classList.add('no-anim');
                current.classList.remove('is-leaving');
                /* Force reflow so the no-anim reset takes effect instantly. */
                void current.offsetWidth;
                current.classList.remove('no-anim');
              }, fxMs);
            }
            i = next;
          }, delay);
        });
      });
    }

    /* Hold the carousel until the page has fully loaded so it never competes
       with the initial render/load. The first hero image is already in the
       markup; only the rotation and the remaining images are deferred. */
    if (document.readyState === 'complete') {
      start();
    } else {
      window.addEventListener('load', start);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-router"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-cart-router]');
    if (!root) return;

    if (window.Shopify && window.Shopify.designMode) return;

    var code         = (root.dataset.discount || '').trim();
    var urlWithItems = root.dataset.urlWithItems || '/checkout';
    var urlWhenEmpty = root.dataset.urlWhenEmpty || '/';

    function buildTarget(hasItems) {
      var dest = hasItems ? urlWithItems : urlWhenEmpty;
      if (code) {
        return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(dest);
      }
      return dest;
    }

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        window.location.replace(buildTarget(cart.item_count > 0));
      })
      .catch(function () {
        window.location.replace(buildTarget(false));
      });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["holiday-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.hb').forEach(function (bar) {
      var dismissKey = bar.getAttribute('data-dismiss-key');
      if (dismissKey) {
        try {
          if (localStorage.getItem(dismissKey) === '1') {
            bar.classList.add('is-hidden');
            return;
          }
        } catch (e) {}
        var closeBtn = bar.querySelector('[data-hb-close]');
        if (closeBtn) closeBtn.addEventListener('click', function () {
          bar.classList.add('is-hidden');
          try { localStorage.setItem(dismissKey, '1'); } catch (e) {}
        });
      }

      bar.querySelectorAll('[data-mm-countdown]').forEach(function (el) {
        if (el.dataset.hbBound === '1') return;
        el.dataset.hbBound = '1';
        var total = parseInt(el.dataset.minutes, 10) * 60;
        var remaining = total;
        function pad(n) { return String(n).padStart(2, '0'); }
        function tick() {
          var h = Math.floor(remaining / 3600);
          var m = Math.floor((remaining % 3600) / 60);
          var s = remaining % 60;
          el.textContent = '00 : ' + pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
          remaining = remaining <= 0 ? total : remaining - 1;
        }
        tick();
        setInterval(tick, 1000);
      });

      if (bar.getAttribute('data-rotate') !== 'true') return;
      var msgs = bar.querySelectorAll('[data-hb-msg]');
      if (msgs.length < 2) return;

      var styles = getComputedStyle(bar);
      var interval = parseInt(styles.getPropertyValue('--hb-rotate-ms'), 10) || 4000;
      var fadeMs   = parseInt(styles.getPropertyValue('--hb-fade-ms'), 10) || 400;
      var i = 0;

      setInterval(function () {
        var current = msgs[i];
        i = (i + 1) % msgs.length;
        var next = msgs[i];
        current.classList.remove('is-active');
        setTimeout(function () { next.classList.add('is-active'); }, fadeMs);
      }, interval);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-aov-boosters"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // ── Tier ATC ────────────────────────────────────────────────────────
    var tierAtc = document.querySelector('[data-mm-aov-atc]');
    if (tierAtc) {
      tierAtc.addEventListener('click', function() {
        var checked = document.querySelector('[data-mm-tier-input]:checked');
        if (!checked) return;
        var vid = checked.getAttribute('data-variant-id');
        var qty = parseInt(checked.getAttribute('data-quantity'), 10) || 1;
        if (!vid) return;
        tierAtc.disabled = true;
        var origText = tierAtc.innerHTML;
        tierAtc.textContent = 'Adding…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(vid, 10), quantity: qty }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          document.dispatchEvent(new CustomEvent('mm:cart:updated'));
          tierAtc.textContent = '✓ Added';
          setTimeout(function() {
            window.location.href = '/cart';
          }, 500);
        })
        .catch(function() {
          tierAtc.disabled = false;
          tierAtc.innerHTML = origText;
        });
      });
    }

    // ── FBT total + ATC ─────────────────────────────────────────────────
    var fbt = document.querySelector('[data-mm-fbt]');
    if (fbt) {
      var inputs = Array.from(fbt.querySelectorAll('[data-mm-fbt-input]'));
      var totalEl = fbt.querySelector('[data-mm-fbt-total]');
      var fbtAtc  = fbt.querySelector('[data-mm-fbt-atc]');

      function fmtMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }
      function recalc() {
        var total = 0;
        inputs.forEach(function(i) {
          if (i.checked) total += parseInt(i.getAttribute('data-price'), 10) || 0;
        });
        if (totalEl) totalEl.textContent = fmtMoney(total);
      }
      inputs.forEach(function(i) { i.addEventListener('change', recalc); });
      recalc();

      if (fbtAtc) {
        fbtAtc.addEventListener('click', function() {
          var items = inputs
            .filter(function(i) { return i.checked && i.getAttribute('data-variant-id'); })
            .map(function(i) { return { id: parseInt(i.getAttribute('data-variant-id'), 10), quantity: 1 }; });
          if (!items.length) return;
          fbtAtc.disabled = true;
          var orig = fbtAtc.textContent;
          fbtAtc.textContent = 'Adding…';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
          .then(function(r) { return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('mm:cart:updated'));
            fbtAtc.textContent = '✓ Added';
            setTimeout(function() { window.location.href = '/cart'; }, 500);
          })
          .catch(function() { fbtAtc.disabled = false; fbtAtc.textContent = orig; });
        });
      }
    }

    // ── Free shipping bar (live update via fetch on cart change) ────────
    var bar = document.querySelector('[data-mm-shipbar]');
    if (bar) {
      var threshold = parseInt(bar.getAttribute('data-threshold'), 10) || 0;
      var fillEl = bar.querySelector('[data-mm-shipbar-fill]');
      var textEl = bar.querySelector('[data-mm-shipbar-text]');

      function fmt(cents) { return '$' + (cents / 100).toFixed(2); }
      function update(totalPrice) {
        var pct = Math.min(100, Math.round((totalPrice / threshold) * 100));
        if (fillEl) fillEl.style.width = pct + '%';
        if (textEl) {
          if (totalPrice < threshold) {
            textEl.innerHTML = 'Add <strong>' + fmt(threshold - totalPrice) + '</strong> more for <strong>FREE shipping</strong>';
          } else {
            textEl.innerHTML = '🎉 You\'ve unlocked <strong>FREE shipping</strong>';
          }
        }
      }
      function refresh() {
        fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
          .then(function(r) { return r.json(); })
          .then(function(c) { update(c.total_price); })
          .catch(function() {});
      }
      document.addEventListener('mm:cart:updated', refresh);
      // Also catch native form submits or other ATC events
      document.addEventListener('cart:updated', refresh);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-hero"]) return;
  try {
    
  (function() {
    // Shared handle so non-gallery code (e.g. the kaching swatch chip click)
    // can swap the main slide when the customer picks a color/design.
    var galleryGoTo = null;

    // ── Gallery ──────────────────────────────────────────────────────────
    const gallery = document.getElementById('mm-main-gallery');
    if (gallery) {
      const track   = gallery.querySelector('[data-mm-gallery-track]');
      const slides  = track ? Array.from(track.children) : [];
      const section = gallery.closest('.mm-hero');
      const thumbs  = section ? Array.from(section.querySelectorAll('.mm-hero__thumb')) : [];
      const prevBtn = gallery.querySelector('[data-mm-gallery-prev]');
      const nextBtn = gallery.querySelector('[data-mm-gallery-next]');

      let current = 0;
      const last = slides.length - 1;
      let loadedThrough = 4;

      const thumbsContainer = thumbs[0] ? thumbs[0].parentElement : null;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      function scrollThumbIntoView(idx) {
        const thumb = thumbs[idx];
        if (!thumb || !thumbsContainer) return;
        const cw = thumbsContainer.clientWidth;
        const ch = thumbsContainer.clientHeight;
        const sw = thumbsContainer.scrollWidth;
        const sh = thumbsContainer.scrollHeight;
        const opts = { behavior: reduceMotion ? 'auto' : 'smooth' };
        let needs = false;
        if (sw > cw + 1) {
          const target = thumb.offsetLeft - (cw - thumb.offsetWidth) / 2;
          opts.left = Math.max(0, Math.min(target, sw - cw));
          needs = true;
        }
        if (sh > ch + 1) {
          const target = thumb.offsetTop - (ch - thumb.offsetHeight) / 2;
          opts.top = Math.max(0, Math.min(target, sh - ch));
          needs = true;
        }
        if (needs) thumbsContainer.scrollTo(opts);
      }

      function ensureLoadedTo(idx) {
        const target = Math.min(idx + 4, last);
        if (target <= loadedThrough) return;
        for (let i = loadedThrough + 1; i <= target; i++) {
          const img = slides[i] && slides[i].querySelector('img[data-mm-deferred]');
          if (!img) continue;
          const realSrc = img.getAttribute('data-src');
          const realSrcset = img.getAttribute('data-srcset');
          if (realSrcset) img.setAttribute('srcset', realSrcset);
          if (realSrc) img.setAttribute('src', realSrc);
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
          img.removeAttribute('data-mm-deferred');
        }
        loadedThrough = target;
      }

      function setArrow(btn, disabled) {
        if (!btn) return;
        btn.disabled = disabled;
        btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }

      // Lazy slide → design-value map. Each variant claims its trigger
      // slide (featured_media position) and every slide to the right of it
      // until the next variant's trigger. So if variant A's trigger is at
      // slide 1 and variant B's at slide 4, slides 1-3 show A's name and
      // slides 4+ show B's (until C's trigger, etc.). Going one slide
      // LEFT of a trigger naturally lands in the previous variant's zone,
      // which is the behavior the user expects.
      var slideDesignMap = null;
      function getSlideDesignMap() {
        if (slideDesignMap !== null) return slideDesignMap;
        slideDesignMap = {};
        var variants = (typeof getMmVariants === 'function') ? getMmVariants() : [];
        if (!variants.length) return slideDesignMap;

        var optNames = [];
        var optNamesScript = document.querySelector('[data-mm-product-option-names]');
        if (optNamesScript) {
          try { optNames = JSON.parse(optNamesScript.textContent) || []; } catch (e) {}
        }
        var designIdx = -1;
        for (var i = 0; i < optNames.length; i++) {
          if (typeof getOptionType === 'function' && getOptionType(optNames[i]) !== 'size') { designIdx = i; break; }
        }
        if (designIdx < 0) return slideDesignMap;

        var posMap = (typeof getMmPositionMap === 'function') ? getMmPositionMap() : null;
        var hasPosMap = !!(posMap && Object.keys(posMap).length);

        // First pass: per-slide trigger map (first variant wins per slide).
        var triggers = {};
        for (var v = 0; v < variants.length; v++) {
          var variant = variants[v];
          var fm = variant.featured_media || variant.featured_image;
          if (!fm || typeof fm.position !== 'number' || fm.position < 1) continue;
          var sIdx;
          if (hasPosMap) {
            var mapped = posMap[String(fm.position)];
            if (typeof mapped !== 'number') continue; // media was pruned (sold-out variant)
            sIdx = mapped;
          } else {
            sIdx = fm.position - 1;
          }
          if (triggers[sIdx] !== undefined) continue;
          var ops = (variant.options && variant.options.length) ? variant.options : [variant.option1, variant.option2, variant.option3];
          var val = ops[designIdx];
          if (val) triggers[sIdx] = val;
        }

        // Second pass: carry each trigger forward across slides until the
        // next trigger overrides it.
        var totalSlides = last + 1;
        var carry = null;
        for (var s = 0; s < totalSlides; s++) {
          if (triggers[s] !== undefined) carry = triggers[s];
          if (carry) slideDesignMap[s] = carry;
        }
        return slideDesignMap;
      }

      function goTo(idx) {
        if (idx < 0) idx = 0;
        if (idx > last) idx = last;
        if (idx === current) return;

        ensureLoadedTo(idx);

        if (track) track.style.transform = 'translateX(' + (-idx * 100) + '%)';

        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        slides[idx].classList.add('is-active');
        slides[idx].setAttribute('aria-hidden', 'false');

        if (thumbs[current]) thumbs[current].setAttribute('aria-selected', 'false');
        if (thumbs[idx])     thumbs[idx].setAttribute('aria-selected', 'true');

        scrollThumbIntoView(idx);

        current = idx;
        setArrow(prevBtn, current <= 0);
        setArrow(nextBtn, current >= last);

        // Mirror the swatch-click UX: when the slide changes, surface the
        // design name for that slide via the same variant label.
        var dv = getSlideDesignMap()[idx];
        if (dv && typeof setVariantLabel === 'function') setVariantLabel(dv);
      }

      galleryGoTo = goTo;

      thumbs.forEach(function(btn, i) {
        btn.addEventListener('click', function() { goTo(i); });
      });
      if (prevBtn) prevBtn.addEventListener('click', function() { goTo(current - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function() { goTo(current + 1); });

      setArrow(prevBtn, true);
      setArrow(nextBtn, last <= 0);

      // Touch swipe — commits past 40px, clamps at ends.
      // The gesture axis is locked on the first ~10px of movement: a mostly-
      // horizontal swipe drives the carousel and we preventDefault so the page
      // can't scroll under it (this is what stops an imperfect swipe from
      // "pulling the page down"); a mostly-vertical swipe is left alone so the
      // page scrolls normally.
      let startX = null, startY = null, axis = null;
      gallery.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        startY = e.touches[0].clientY;
        axis = null;
      }, { passive: true });
      gallery.addEventListener('touchmove', function(e) {
        if (startX === null) return;
        const dx = e.touches[0].clientX - startX;
        const dy = e.touches[0].clientY - startY;
        if (axis === null && (Math.abs(dx) > 10 || Math.abs(dy) > 10)) {
          axis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        }
        // Lock the page once we know the swipe is horizontal.
        if (axis === 'x') e.preventDefault();
      }, { passive: false });
      gallery.addEventListener('touchend', function(e) {
        if (startX === null) return;
        const dx = e.changedTouches[0].clientX - startX;
        if (axis === 'x' && Math.abs(dx) > 40) goTo(dx < 0 ? current + 1 : current - 1);
        startX = null; startY = null; axis = null;
      }, { passive: true });
    }

    // ── Mini review carousel ──────────────────────────────────────────────
    const reviewWrap = document.querySelector('[data-mm-mini-reviews]');
    if (reviewWrap) {
      const reviews = Array.from(reviewWrap.querySelectorAll('.mm-buybox__review'));
      const dotsWrap = reviewWrap.querySelector('.mm-buybox__review-dots');
      let rCurrent = 0;

      // Build dots
      if (dotsWrap && reviews.length > 1) {
        reviews.forEach(function(_, i) {
          var d = document.createElement('span');
          d.className = 'mm-buybox__review-dot' + (i === 0 ? ' mm-buybox__review-dot--active' : '');
          dotsWrap.appendChild(d);
        });
      }

      function goToReview(idx) {
        if (idx < 0) idx = reviews.length - 1;
        if (idx >= reviews.length) idx = 0;
        reviews[rCurrent].hidden = true;
        var dots = dotsWrap ? Array.from(dotsWrap.querySelectorAll('.mm-buybox__review-dot')) : [];
        if (dots[rCurrent]) dots[rCurrent].classList.remove('mm-buybox__review-dot--active');
        rCurrent = idx;
        reviews[rCurrent].hidden = false;
        if (dots[rCurrent]) dots[rCurrent].classList.add('mm-buybox__review-dot--active');
      }

      var prevR = reviewWrap.querySelector('[data-mm-mini-review-prev]');
      var nextR = reviewWrap.querySelector('[data-mm-mini-review-next]');
      if (prevR) prevR.addEventListener('click', function(e) { e.preventDefault(); goToReview(rCurrent - 1); });
      if (nextR) nextR.addEventListener('click', function(e) { e.preventDefault(); goToReview(rCurrent + 1); });
    }

    // ── Analytics shim — push to dataLayer + dispatch a DOM event ────────
    function mmTrack(name, payload) {
      try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name }, payload || {})); } catch (e) {}
      try { document.dispatchEvent(new CustomEvent('mm:analytics', { detail: { event: name, payload: payload || {} } })); } catch (e) {}
    }

    // ── Sizing chart unit toggle (drives chart cells AND finder chips) ───
    document.querySelectorAll('[data-mm-sizing]').forEach(function(el) {
      var startUnit = el.getAttribute('data-default-unit') === 'cm' ? 'cm' : 'in';
      var buttons = el.querySelectorAll('[data-mm-sizing-unit]');
      function apply(u) {
        el.dataset.unit = u;
        el.querySelectorAll('[data-in][data-cm]').forEach(function(c) {
          var v = c.getAttribute('data-' + u);
          if (v === null || v === '') { c.textContent = ''; return; }
          c.textContent = u === 'in' ? (v + '"') : (v + ' cm');
        });
        buttons.forEach(function(b) {
          var active = b.getAttribute('data-mm-sizing-unit') === u;
          b.classList.toggle('is-active', active);
          b.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        // Keep the Quick finder's height/weight labels + unit switch in step with
        // the chart toggle. renderInputs() touches no chart/chip state, so this
        // can't recurse back into apply().
        if (el.__mmRenderFitInputs) el.__mmRenderFitInputs();
      }
      el.__mmApplyUnit = apply;
      buttons.forEach(function(b) {
        b.addEventListener('click', function() { apply(b.getAttribute('data-mm-sizing-unit')); });
      });
      apply(startUnit);
    });

    // ── Highlight the currently chosen size row in every chart ───────────
    window.__mmHighlightChartRow = function(size) {
      document.querySelectorAll('.mm-sizing__table--pick tbody tr').forEach(function(tr) {
        var th = tr.querySelector('th');
        var s = th ? th.textContent.trim() : '';
        tr.classList.toggle('is-selected', !!size && s === size);
      });
    };
    window.addEventListener('mm:size:changed', function(e) {
      var size = e.detail && e.detail.size;
      if (size) window.__mmHighlightChartRow(size);
    });

    // ── Quick finder — estimate a size from height + weight, map to chart ─
    function setupFitFinder(dlg) {
      var fit = dlg.querySelector('[data-mm-fit]');
      if (!fit || fit.dataset.mmFitReady === '1') return;
      fit.dataset.mmFitReady = '1';

      var heightInput = fit.querySelector('[data-mm-fit-height]');
      var weightInput = fit.querySelector('[data-mm-fit-weight]');
      var heightLabel = fit.querySelector('[data-mm-fit-height-label]');
      var weightLabel = fit.querySelector('[data-mm-fit-weight-label]');
      var segBtns = fit.querySelectorAll('[data-mm-fit-pref]');
      var sizeEl = fit.querySelector('[data-mm-fit-size]');
      var reasonEl = fit.querySelector('[data-mm-fit-reason]');
      // The apply button lives in the sheet's pinned footer (outside .mm-fit).
      var applyBtn = dlg.querySelector('[data-mm-fit-apply]');
      var applySizeEl = dlg.querySelector('[data-mm-fit-apply-size]');
      var chips = {
        waist: fit.querySelector('[data-mm-fit-chip="waist"]'),
        inseam: fit.querySelector('[data-mm-fit-chip="inseam"]'),
        hip: fit.querySelector('[data-mm-fit-chip="hip"]')
      };
      var unitBtns = fit.querySelectorAll('[data-mm-fit-unit]');
      var pref = 'True';
      var lastEdge = false;
      // Tallest reason copy seen this session. The dark card only ever grows to
      // fit it and never shrinks, so scrubbing the sliders can't jitter the sheet.
      var reasonFloor = 0;

      // Read the real chart so recommendations + chips come straight from it.
      function readChart() {
        var arr = [];
        dlg.querySelectorAll('.mm-sizing__table--pick tbody tr').forEach(function(tr) {
          var th = tr.querySelector('th');
          var tds = tr.querySelectorAll('td[data-in]');
          if (!th || tds.length < 2) return;
          arr.push({ size: th.textContent.trim(), waist: parseFloat(tds[0].getAttribute('data-in')), tds: tds });
        });
        arr.sort(function(a, b) { return a.waist - b.waist; });
        return arr;
      }

      function setChip(key, td) {
        var chip = chips[key];
        if (!chip) return;
        var wrap = chip.closest('.mm-fit__chip');
        if (!td) {
          if (wrap) wrap.setAttribute('data-empty', '1');
          chip.setAttribute('data-in', ''); chip.setAttribute('data-cm', '');
          return;
        }
        if (wrap) wrap.removeAttribute('data-empty');
        chip.setAttribute('data-in', td.getAttribute('data-in') || '');
        chip.setAttribute('data-cm', td.getAttribute('data-cm') || '');
      }

      // Render the height/weight labels + the unit switch from the shared unit
      // ('in' | 'cm' on the dialog). The slider values stay imperial internally —
      // only the *display* converts — so the chart-derived recommendation below
      // is identical in either unit. Touches no chart/chip state, so it's safe to
      // call from the chart tab's unit toggle without recursing into compute().
      function renderInputs() {
        var metric = dlg.dataset.unit === 'cm';
        var h = parseInt(heightInput.value, 10);
        var w = parseInt(weightInput.value, 10);
        if (heightLabel) {
          heightLabel.textContent = metric
            ? Math.round(h * 2.54) + ' cm'
            : Math.floor(h / 12) + "'" + (h % 12) + '"';
        }
        if (weightLabel) {
          weightLabel.textContent = metric
            ? Math.round(w * 0.45359237) + ' kg'
            : w + ' lb';
        }
        unitBtns.forEach(function(b) {
          var on = (b.getAttribute('data-mm-fit-unit') === 'metric') === metric;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }

      function compute() {
        var h = parseInt(heightInput.value, 10);
        var w = parseInt(weightInput.value, 10);
        renderInputs();

        var chart = readChart();
        if (!chart.length) return;

        // Estimate body waist, then map onto the nearest charted size.
        var est = (w * 0.11) + 12 + ((70 - h) * 0.12);
        var nearest = 0, best = Infinity;
        for (var i = 0; i < chart.length; i++) {
          var d = Math.abs(chart[i].waist - est);
          if (d < best) { best = d; nearest = i; }
        }
        var between = (est - chart[nearest].waist) > 0.7;
        var idx = nearest;
        if (pref === 'Relaxed') idx += 1;
        else if (pref === 'Snug') idx -= 1;
        // Room-for-error: honor the printed "size up if you're between" guidance.
        if (between && pref !== 'Snug') idx += 1;

        // Edge-of-range guard: nothing fits cleanly past a stretched 3XL.
        var edge = false;
        if (est > 41.8) { idx = chart.length - 1; edge = true; }
        if (idx < 0) idx = 0;
        if (idx > chart.length - 1) idx = chart.length - 1;
        var rec = chart[idx];

        var reason;
        if (pref === 'Snug') reason = 'Sized for a trimmer, closer cut.';
        else if (pref === 'Relaxed') reason = 'Sized up for a roomier feel.';
        else if (between) reason = "You're right between sizes — so we sized you up to " + rec.size + ". That's Bubba's own call: size up if you're between.";
        else reason = rec.size + ' fits true to size on a build like yours.';
        if (edge) reason += " You're at the very top of our range — check the chart before buying.";

        if (sizeEl) sizeEl.textContent = rec.size;
        if (applySizeEl) applySizeEl.textContent = rec.size;
        if (reasonEl) {
          reasonEl.textContent = reason;
          // Measure this copy's natural height, then lock the box to the tallest
          // seen so far. Both writes happen before paint, so there's no flicker —
          // the sheet only ever expands (once), never shrinks mid-drag.
          reasonEl.style.minHeight = '0px';
          var natural = reasonEl.offsetHeight;
          if (natural > reasonFloor) reasonFloor = natural;
          reasonEl.style.minHeight = reasonFloor + 'px';
        }
        if (applyBtn) applyBtn.setAttribute('data-rec-size', rec.size);

        setChip('waist', rec.tds[0]);
        setChip('inseam', rec.tds[1]);
        setChip('hip', rec.tds[2]);
        if (dlg.__mmApplyUnit) dlg.__mmApplyUnit(dlg.dataset.unit || 'in');

        if (edge && !lastEdge) mmTrack('size_edge_warning', { size: rec.size, est_waist: Math.round(est * 10) / 10 });
        lastEdge = edge;
      }

      function trackInput() {
        mmTrack('fit_finder_input', {
          height: parseInt(heightInput.value, 10),
          weight: parseInt(weightInput.value, 10),
          pref: pref
        });
      }

      // Coalesce slider input to one recompute per frame (a drag fires many).
      var computeQueued = false;
      function scheduleCompute() {
        if (computeQueued) return;
        computeQueued = true;
        requestAnimationFrame(function() { computeQueued = false; compute(); });
      }
      if (heightInput) {
        heightInput.addEventListener('input', scheduleCompute);
        heightInput.addEventListener('change', trackInput);
      }
      if (weightInput) {
        weightInput.addEventListener('input', scheduleCompute);
        weightInput.addEventListener('change', trackInput);
      }
      segBtns.forEach(function(b) {
        b.addEventListener('click', function() {
          pref = b.getAttribute('data-mm-fit-pref');
          segBtns.forEach(function(x) {
            var on = x === b;
            x.classList.toggle('is-active', on);
            x.setAttribute('aria-pressed', on ? 'true' : 'false');
          });
          compute();
          trackInput();
        });
      });
      // Imperial / metric switch. Routes through the shared unit system so the
      // size chart cells and the Waist/Inseam/Hip chips (which are read straight
      // from the chart) stay in the same unit. The recommendation is unchanged.
      unitBtns.forEach(function(b) {
        b.addEventListener('click', function() {
          var u = b.getAttribute('data-mm-fit-unit') === 'metric' ? 'cm' : 'in';
          if (dlg.__mmApplyUnit) {
            dlg.__mmApplyUnit(u);
          } else {
            dlg.dataset.unit = u;
            renderInputs();
          }
          mmTrack('fit_finder_units', { unit: u });
        });
      });
      if (applyBtn) {
        applyBtn.addEventListener('click', function() {
          var size = applyBtn.getAttribute('data-rec-size') || (sizeEl && sizeEl.textContent) || '';
          if (!size) return;
          // Dismiss instantly; run the (cheap) DOM work on the next frame so the
          // sheet close never waits on it. applySize already highlights the chart.
          if (typeof dlg.close === 'function') { dlg.close(); } else { dlg.removeAttribute('open'); }
          requestAnimationFrame(function() {
            mmTrack('fit_finder_apply', {
              size: size,
              height: parseInt(heightInput.value, 10),
              weight: parseInt(weightInput.value, 10),
              pref: pref
            });
            if (window.MMOfferStack && window.MMOfferStack.applySize) window.MMOfferStack.applySize(size, 'finder');
          });
        });
      }

      dlg.__mmFitCompute = compute;
      dlg.__mmRenderFitInputs = renderInputs;
      compute();
    }

    // ── Tab switching inside the sheet ───────────────────────────────────
    function setSizingTab(dlg, tab, entry) {
      if (!dlg || !tab) return;
      dlg.querySelectorAll('[data-mm-sizing-tab]').forEach(function(b) {
        var on = b.getAttribute('data-mm-sizing-tab') === tab;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      dlg.querySelectorAll('[data-mm-sizing-panel]').forEach(function(pn) {
        var on = pn.getAttribute('data-mm-sizing-panel') === tab;
        pn.classList.toggle('is-active', on);
        pn.hidden = !on;
      });
      // The pinned "Use [size]" footer belongs to the finder only.
      var footer = dlg.querySelector('[data-mm-sizing-footer]');
      if (footer) footer.hidden = (tab !== 'finder');
      if (tab === 'finder') {
        if (dlg.__mmFitCompute) dlg.__mmFitCompute();
        mmTrack('fit_finder_open', { entry: entry || 'unknown' });
      } else if (tab === 'chart') {
        mmTrack('chart_tab_view', { entry: entry || 'unknown' });
      }
    }

    // In-sheet tab buttons (filter to the pill buttons so the fit_line
    // anchor that also carries data-mm-sizing-tab isn't double-handled here).
    document.addEventListener('click', function(e) {
      var t = e.target.closest('.mm-sizing__tab[data-mm-sizing-tab]');
      if (!t) return;
      e.preventDefault();
      setSizingTab(t.closest('[data-mm-sizing]'), t.getAttribute('data-mm-sizing-tab'), 'tab');
    });

    // Mobile bottom-sheet slide-up. The panel is anchored to the viewport bottom
    // (position: fixed) so its rest never moves; this just slides it in from
    // below. Desktop keeps its CSS reveal.
    function mmPlaySheetEntrance(dlg) {
      var panel = dlg.querySelector('.mm-sizing__panel');
      if (!panel) return;
      if (window.matchMedia && window.matchMedia('(min-width: 700px)').matches) return;
      // Park it fully below the viewport before the first paint, then transition
      // up. translateY(100%) keeps it off-screen regardless of final height.
      panel.__mmEntrancing = true;
      panel.style.transition = 'none';
      panel.style.transform = 'translateY(100%)';
      void panel.offsetHeight; // flush the start state
      requestAnimationFrame(function() {
        if (!panel.__mmEntrancing) return; // a drag took over before we started
        panel.style.transition = 'transform 320ms cubic-bezier(.22,.61,.36,1)';
        panel.style.transform = 'translateY(0)';
        // Hand control back to the resting state once settled. The flag guards
        // against a drag that grabs the panel mid-slide (see dStart).
        setTimeout(function() {
          if (!panel.__mmEntrancing) return;
          panel.__mmEntrancing = false;
          panel.style.transition = '';
          panel.style.transform = '';
        }, 360);
      });
    }

    // Public opener: open the sheet on a given tab (default Quick finder).
    window.__mmOpenSizing = function(tab, entry) {
      var dlg = document.querySelector('[data-mm-sizing]');
      if (!dlg) return;
      var wasOpen = dlg.open;
      // The dialog uses position:fixed + showModal() to cover the viewport. Any
      // ancestor with transform / filter / backdrop-filter / will-change (the
      // hero has several) becomes the containing block for fixed children and
      // clips the top-layer scrim — trapping the panel in a corner with no
      // working backdrop, so it can't be dismissed. Re-home to <body> on every
      // open so it always escapes; idempotent, and survives section re-renders
      // that the one-time init relocation below would miss.
      if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
      try {
        if (typeof dlg.showModal === 'function') { if (!dlg.open) dlg.showModal(); }
        else dlg.setAttribute('open', '');
      } catch (err) {
        // Stuck open as a non-modal dialog (no scrim, Escape dead) — normalize.
        try { dlg.close(); } catch (e2) {}
        if (typeof dlg.showModal === 'function') dlg.showModal();
        else dlg.setAttribute('open', '');
      }
      setSizingTab(dlg, tab || 'finder', entry);
      // Only animate when we actually opened it — re-clicking an open sheet
      // shouldn't make it slide down and back up.
      if (!wasOpen) mmPlaySheetEntrance(dlg);
      if (window.MMOfferStack && window.MMOfferStack.getSize) {
        var s = window.MMOfferStack.getSize();
        if (s && window.__mmHighlightChartRow) window.__mmHighlightChartRow(s);
      }
    };

    // ── Chart rows double as a size picker ───────────────────────────────
    document.querySelectorAll('[data-mm-sizing]').forEach(function(dlg) {
      setupFitFinder(dlg);
      dlg.querySelectorAll('.mm-sizing__table--pick tbody tr').forEach(function(tr) {
        var th = tr.querySelector('th');
        var size = th ? th.textContent.trim() : '';
        tr.setAttribute('tabindex', '0');
        tr.setAttribute('role', 'button');
        if (size) tr.setAttribute('aria-label', 'Choose size ' + size);
      });
    });
    document.addEventListener('click', function(e) {
      var tr = e.target.closest('.mm-sizing__table--pick tbody tr');
      if (!tr) return;
      var th = tr.querySelector('th');
      var size = th ? th.textContent.trim() : '';
      if (!size) return;
      if (window.MMOfferStack && window.MMOfferStack.applySize) window.MMOfferStack.applySize(size, 'chart');
      mmTrack('chart_row_select', { size: size });
      if (window.__mmHighlightChartRow) window.__mmHighlightChartRow(size);
      var dlg = tr.closest('[data-mm-sizing]');
      if (dlg) { if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open'); }
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var tr = e.target && e.target.closest && e.target.closest('.mm-sizing__table--pick tbody tr');
      if (!tr) return;
      e.preventDefault();
      tr.click();
    });

    // ── Variant picker — "Size Guide" link opens the sizing-chart popup ─
    document.querySelectorAll('[data-mm-vp-size-guide]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        // Go through the shared opener so the dialog is re-homed to <body>
        // (escapes transformed ancestors) and opens as a proper modal.
        if (window.__mmOpenSizing) window.__mmOpenSizing('chart', 'vp-size-guide');
      });
    });

    // ── Variant picker → Kaching select sync ────────────────────────────
    // When our Luna picker changes, mirror the same option value into any
    // Kaching variant select with a matching data-name. Kaching observes its
    // own selects (not the form variant id), so we have to drive both.
    function syncKachingSelects() {
      document.querySelectorAll('[data-mm-vp] [data-mm-vp-sync-name]').forEach(function(input) {
        if (!input.checked) return;
        var name = input.getAttribute('data-mm-vp-sync-name');
        var value = input.value;
        document.querySelectorAll('select.kaching-bundles__bar-variant-select[data-name="' + CSS.escape(name) + '"]').forEach(function(sel) {
          if (sel.value === value) return;
          // Verify the option exists before setting (kaching hides unavailable variants).
          var hasOption = Array.prototype.some.call(sel.options, function(o) { return o.value === value; });
          if (!hasOption) return;
          sel.value = value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    document.querySelectorAll('[data-mm-vp] [data-mm-vp-sync-name]').forEach(function(input) {
      input.addEventListener('change', syncKachingSelects);
    });
    // Sync once on load (kaching may finish hydration after this fires; retry briefly).
    var syncTries = 0;
    var syncTimer = setInterval(function() {
      syncKachingSelects();
      if (++syncTries > 10) clearInterval(syncTimer);
    }, 400);

    // ── Kaching variant enhancer — pills + swatches (Luna look) ─────────
    // Rewrites each <select.kaching-bundles__bar-variant-select> into a
    // chip row (size = pill buttons, color/design = circle swatches).
    // The original select stays in the DOM (kaching observes it); we drive
    // it programmatically when the user clicks a chip.
    function getOptionType(name) {
      var lc = (name || '').toLowerCase();
      if (lc.indexOf('size') !== -1) return 'size';
      if (lc.indexOf('color') !== -1 || lc.indexOf('colour') !== -1 || lc.indexOf('design') !== -1 || lc.indexOf('pattern') !== -1 || lc.indexOf('style') !== -1) return 'color';
      return 'other';
    }

    // Variants JSON for resolving a chosen color/design value to the slide
    // index of that variant's featured media. Cached on first read.
    var mmVariantsCache = null;
    function getMmVariants() {
      if (mmVariantsCache !== null) return mmVariantsCache;
      var sc = document.querySelector('[data-mm-variants-json]');
      if (!sc) { mmVariantsCache = []; return mmVariantsCache; }
      try { mmVariantsCache = JSON.parse(sc.textContent) || []; } catch (e) { mmVariantsCache = []; }
      return mmVariantsCache;
    }
    // Maps a variant's original featured_media.position to the rendered slide
    // index after sold-out variant media have been pruned. Missing key ⇒ media
    // belonged to a sold-out variant and isn't in the carousel.
    var mmPositionMapCache = null;
    function getMmPositionMap() {
      if (mmPositionMapCache !== null) return mmPositionMapCache;
      var sc = document.querySelector('[data-mm-media-position-map]');
      if (!sc) { mmPositionMapCache = {}; return mmPositionMapCache; }
      try { mmPositionMapCache = JSON.parse(sc.textContent) || {}; } catch (e) { mmPositionMapCache = {}; }
      return mmPositionMapCache;
    }
    // Map every option value → its gallery slide index ONCE (cached), so a
    // swatch click is an O(1) lookup instead of scanning every variant. The
    // first variant (in order) that has media and contains a value wins — same
    // result as the old first-match-with-media scan.
    var mmValueSlideMap = null;
    function getMmValueSlideMap() {
      if (mmValueSlideMap !== null) return mmValueSlideMap;
      mmValueSlideMap = {};
      var variants = getMmVariants();
      var posMap = getMmPositionMap();
      var hasPosMap = posMap && Object.keys(posMap).length;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var fm = v.featured_media || v.featured_image;
        var pos = fm && fm.position;
        if (typeof pos !== 'number' || pos <= 0) continue;
        var target;
        if (hasPosMap) {
          var mapped = posMap[String(pos)];
          if (typeof mapped !== 'number') continue; // pruned (sold-out) media
          target = mapped;
        } else {
          target = pos - 1;
        }
        var ops = (v.options && v.options.length) ? v.options : [v.option1, v.option2, v.option3];
        for (var j = 0; j < ops.length; j++) {
          var val = ops[j];
          if (val == null || val === '') continue;
          if (!(val in mmValueSlideMap)) mmValueSlideMap[val] = target;
        }
      }
      return mmValueSlideMap;
    }
    function syncGalleryToOption(optionName, optionValue) {
      window.__mmLastSync = { optionName: optionName, optionValue: optionValue, galleryGoTo: typeof galleryGoTo };
      if (typeof galleryGoTo !== 'function') { window.__mmLastSync.reason = 'no-gallery'; return; }
      // Size never swaps the gallery; every other option (Design/Pattern/…) does.
      if (getOptionType(optionName) === 'size') { window.__mmLastSync.reason = 'size-skip'; return; }
      var target = getMmValueSlideMap()[optionValue];
      if (typeof target !== 'number') { window.__mmLastSync.reason = 'no-match'; return; }
      window.__mmLastSync.target = target;
      galleryGoTo(target);
      setVariantLabel(optionValue);
      window.__mmLastSync.reason = 'ok';
    }
    var mmVariantLabelHideTimer = null;
    var mmVariantLabelDismiss = null;
    var mmVariantLabelStartY = 0;
    // Swap the under-image model note (caption A vs B) for the chosen design.
    // The B-list is the designs that should show caption B; everything else
    // falls back to caption A. List may be newline- or comma-separated.
    function mmUpdateModelInfo(designValue) {
      var el = document.querySelector('[data-mm-model-info]');
      if (!el) return;
      var capA = el.getAttribute('data-caption-a') || '';
      var capB = el.getAttribute('data-caption-b') || '';
      if (!capB || !designValue) return; // nothing to switch to
      var raw = el.getAttribute('data-caption-b-designs') || '';
      var items = raw.split(/[\n,]+/).map(function (s) { return s.trim().toLowerCase(); }).filter(Boolean);
      var useB = items.indexOf(String(designValue).trim().toLowerCase()) !== -1;
      el.textContent = useB ? capB : capA;
    }

    function setVariantLabel(text) {
      if (text) mmUpdateModelInfo(text);
      var el = document.querySelector('[data-mm-variant-label]');
      if (!el) return;
      if (mmVariantLabelHideTimer) { clearTimeout(mmVariantLabelHideTimer); mmVariantLabelHideTimer = null; }
      if (mmVariantLabelDismiss) {
        document.removeEventListener('click', mmVariantLabelDismiss);
        window.removeEventListener('scroll', mmVariantLabelDismiss);
        mmVariantLabelDismiss = null;
      }
      if (!text) { el.hidden = true; el.textContent = ''; return; }
      el.textContent = text;
      el.hidden = false;

      // Auto-hide after a beat so the label doesn't loiter forever.
      mmVariantLabelHideTimer = setTimeout(function() { el.hidden = true; }, 2500);

      mmVariantLabelStartY = window.scrollY || 0;
      mmVariantLabelDismiss = function(e) {
        // Ignore clicks on any swatch — keep the label visible while the
        // customer is picking. Anything else dismisses immediately.
        if (e && e.type === 'click' && e.target.closest && e.target.closest('.kaching-bundles__swatch-buttons__button, .mm-kw-chip--swatch')) return;
        // Tiny scroll deltas (e.g. iOS rubber-band, sticky-gallery shifts) shouldn't dismiss.
        if (e && e.type === 'scroll' && Math.abs((window.scrollY || 0) - mmVariantLabelStartY) < 30) return;
        el.hidden = true;
        if (mmVariantLabelHideTimer) { clearTimeout(mmVariantLabelHideTimer); mmVariantLabelHideTimer = null; }
        document.removeEventListener('click', mmVariantLabelDismiss);
        window.removeEventListener('scroll', mmVariantLabelDismiss);
        mmVariantLabelDismiss = null;
      };
      // Defer to the next tick so this listener can't fire on the click that
      // just selected the swatch.
      setTimeout(function() {
        if (!mmVariantLabelDismiss) return;
        document.addEventListener('click', mmVariantLabelDismiss);
        window.addEventListener('scroll', mmVariantLabelDismiss, { passive: true });
      }, 0);
    }
    window.__mmSyncGalleryToOption = syncGalleryToOption;

    function openSizingChart(e) {
      if (e && e.preventDefault) e.preventDefault();
      if (window.__mmOpenSizing) window.__mmOpenSizing('chart', 'link');
    }

    document.querySelectorAll('[data-mm-sizing-open]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var tab = btn.getAttribute('data-mm-sizing-tab') || 'finder';
        if (window.__mmOpenSizing) window.__mmOpenSizing(tab, 'pill');
      });
    });

    // Relocate dialogs to <body> so ancestor transforms/filters/contain on the
    // section can't break top-layer positioning (mobile Safari bug surface).
    document.querySelectorAll('[data-mm-sizing]').forEach(function(dlg) {
      if (dlg.parentNode !== document.body) document.body.appendChild(dlg);
      var closeBtn = dlg.querySelector('[data-mm-sizing-close]');
      if (closeBtn) closeBtn.addEventListener('click', function() { dlg.close(); });
      // Click on backdrop closes the dialog
      dlg.addEventListener('click', function(ev) {
        if (ev.target === dlg) dlg.close();
      });
      // Whatever route closes the sheet, clear any leftover slide transform so
      // the next open starts clean.
      dlg.addEventListener('close', function() {
        var pn = dlg.querySelector('.mm-sizing__panel');
        if (pn) { pn.__mmEntrancing = false; pn.style.transition = ''; pn.style.transform = ''; }
      });

      // Grip drag-to-dismiss (mobile bottom sheet) — transform-only, no layout.
      var panel = dlg.querySelector('.mm-sizing__panel');
      var grip = dlg.querySelector('[data-mm-sizing-grip]');
      if (panel && grip) {
        var startY = 0, dy = 0, dragging = false;
        function dStart(e) {
          var p = e.touches ? e.touches[0] : e;
          startY = p.clientY; dy = 0; dragging = true;
          panel.__mmEntrancing = false; // a grab cancels any in-flight open slide
          panel.style.transition = 'none';
        }
        function dMove(e) {
          if (!dragging) return;
          var p = e.touches ? e.touches[0] : e;
          dy = p.clientY - startY;
          if (dy < 0) dy = 0;
          panel.style.transform = 'translateY(' + dy + 'px)';
          if (e.cancelable) e.preventDefault();
        }
        function dEnd() {
          if (!dragging) return;
          dragging = false;
          panel.style.transition = 'transform 240ms cubic-bezier(.2,.8,.2,1)';
          if (dy > 90) {
            panel.style.transform = 'translateY(100%)';
            setTimeout(function() {
              if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
              panel.style.transform = ''; panel.style.transition = '';
            }, 200);
          } else {
            panel.style.transform = 'translateY(0)';
            setTimeout(function() { panel.style.transform = ''; panel.style.transition = ''; }, 260);
          }
        }
        grip.addEventListener('touchstart', dStart, { passive: true });
        grip.addEventListener('touchmove', dMove, { passive: false });
        grip.addEventListener('touchend', dEnd);
        grip.addEventListener('touchcancel', dEnd);
        grip.addEventListener('mousedown', function(e) {
          dStart(e);
          var mm = function(ev) { dMove(ev); };
          var mu = function() { dEnd(); document.removeEventListener('mousemove', mm); document.removeEventListener('mouseup', mu); };
          document.addEventListener('mousemove', mm);
          document.addEventListener('mouseup', mu);
        });
      }
    });

    // Resilient close — delegated at the document so dismissal works even for a
    // dialog added or re-rendered after the one-time wiring above ran (e.g. the
    // theme editor reloading the section, or an app re-rendering the buybox).
    // Covers the ✕ button, a click on the scrim, and the Escape key.
    function mmCloseSizing(dlg) {
      if (!dlg) return;
      if (typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
    }
    document.addEventListener('click', function(e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (t.closest('[data-mm-sizing-close]')) { mmCloseSizing(t.closest('[data-mm-sizing]')); return; }
      if (t.matches && t.matches('[data-mm-sizing]')) mmCloseSizing(t); // click on scrim
    });
    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      mmCloseSizing(document.querySelector('[data-mm-sizing][open]'));
    });

    // ── #size-guide hash trigger — lets richtext links (e.g. FAQ) open the chart ─
    function openSizingFromHash() {
      if (window.location.hash !== '#size-guide') return;
      openSizingChart();
    }
    // Intercept clicks on a[href="#size-guide"] so re-clicking the same hash still opens.
    // The fit_line "Find your fit" link carries data-mm-sizing-tab="finder"; plain
    // "Size Guide" links (e.g. in the FAQ) open the chart.
    document.addEventListener('click', function(ev) {
      var a = ev.target.closest && ev.target.closest('a[href="#size-guide"]');
      if (!a) return;
      ev.preventDefault();
      var tab = a.getAttribute('data-mm-sizing-tab') || 'chart';
      if (window.__mmOpenSizing) window.__mmOpenSizing(tab, 'link');
    });
    window.addEventListener('hashchange', openSizingFromHash);
    openSizingFromHash();

    function buildChip(value, isSelected, chipKind) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'mm-kw-chip mm-kw-chip--' + chipKind + (isSelected ? ' is-selected' : '');
      btn.setAttribute('data-value', value);
      btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
      if (chipKind === 'swatch') {
        var handle = String(value).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
        btn.classList.add('mm-kw-chip--swatch-' + handle);
        btn.setAttribute('title', value);
        var sr = document.createElement('span');
        sr.className = 'mm-kw-chip-sr';
        sr.textContent = value;
        btn.appendChild(sr);
      } else {
        btn.textContent = value;
      }
      return btn;
    }

    function enhanceSelect(select) {
      if (select.dataset.mmKwEnhanced === '1') return;
      select.dataset.mmKwEnhanced = '1';

      var name = select.getAttribute('data-name') || select.getAttribute('aria-label') || '';
      var kind = getOptionType(name);
      var chipKind = kind === 'color' ? 'swatch' : 'pill';

      var control = document.createElement('div');
      control.className = 'mm-kw-control mm-kw-control--' + chipKind;
      control.setAttribute('data-name', name);

      var labelRow = document.createElement('div');
      labelRow.className = 'mm-kw-label-row';

      var label = document.createElement('span');
      label.className = 'mm-kw-label';
      label.innerHTML = '<span class="mm-kw-label-name"></span>: <span class="mm-kw-label-value"></span>';
      label.querySelector('.mm-kw-label-name').textContent = name;
      label.querySelector('.mm-kw-label-value').textContent = select.value;
      labelRow.appendChild(label);

      if (kind === 'size') {
        var bar = select.closest('.kaching-bundles__bar');
        var existingGuide = bar ? bar.querySelector('.mm-kw-size-guide') : null;
        if (!existingGuide) {
          var sg = document.createElement('button');
          sg.type = 'button';
          sg.className = 'mm-kw-size-guide';
          sg.setAttribute('aria-label', 'Open size guide');
          sg.textContent = 'Size Guide';
          sg.addEventListener('click', openSizingChart);
          labelRow.appendChild(sg);
        }
      }

      control.appendChild(labelRow);

      var chipRow = document.createElement('div');
      chipRow.className = 'mm-kw-chips';

      function refresh() {
        label.querySelector('.mm-kw-label-value').textContent = select.value;
        Array.prototype.forEach.call(chipRow.children, function(c) {
          var sel = c.getAttribute('data-value') === select.value;
          c.classList.toggle('is-selected', sel);
          c.setAttribute('aria-pressed', sel ? 'true' : 'false');
        });
      }

      // Build chip for every UNIQUE value we've seen so far (current options).
      // Track all values for later visibility refreshing when kaching prunes options.
      function rebuildChips() {
        chipRow.innerHTML = '';
        Array.prototype.forEach.call(select.options, function(opt) {
          if (opt.value && !mmValueIsAvailable(opt.value)) return;
          var chip = buildChip(opt.value, opt.value === select.value, chipKind);
          chip.addEventListener('click', function() {
            if (select.value === opt.value) return;

            // Snapshot OTHER pairs' selects so we can defeat any cross-pair sync
            // that kaching might apply when this select fires a change event.
            // Each pair's variant_id MUST stay independent.
            var thisPair = select.closest('.kaching-bundles__bar-variant');
            var otherPairSelects = [];
            if (thisPair) {
              document.querySelectorAll('select.kaching-bundles__bar-variant-select.mm-kw-select--enhanced').forEach(function(s) {
                if (s === select) return;
                if (thisPair.contains(s)) return; // same pair (e.g. Size + Design)
                otherPairSelects.push({ el: s, value: s.value });
              });
            }

            select.value = opt.value;
            select.dispatchEvent(new Event('change', { bubbles: true }));
            select.dispatchEvent(new Event('input', { bubbles: true }));
            refresh();

            // Swap the main product slide to the chosen color/design.
            syncGalleryToOption(name, opt.value);

            // Restore other pairs' values if kaching synced them. We DON'T
            // dispatch change on the restore to avoid a feedback loop —
            // kaching's internal state for each pair stays per-pair.
            setTimeout(function() {
              otherPairSelects.forEach(function(p) {
                if (p.el.value !== p.value) {
                  // Verify the original value is still available (kaching may
                  // have pruned options); fall back to the new available value.
                  var stillHas = Array.prototype.some.call(p.el.options, function(o) { return o.value === p.value; });
                  if (stillHas) p.el.value = p.value;
                }
                if (typeof p.el._mmKwRebuild === 'function') p.el._mmKwRebuild();
              });
              // Refresh THIS chip row only (options may have been pruned)
              rebuildChips();
              // Pair progression: advance to next pair on first interaction
              if (thisPair && thisPair.dataset.mmKwInteracted !== '1') {
                thisPair.dataset.mmKwInteracted = '1';
                unlockNextPair(thisPair);
              }
            }, 0);
          });
          chipRow.appendChild(chip);
        });
      }
      rebuildChips();
      control.appendChild(chipRow);

      select.classList.add('mm-kw-select--enhanced');
      select.dataset.mmKwRebuild = ''; // marker so refreshAllChipRows can call rebuildChips
      select._mmKwRebuild = rebuildChips;
      select.insertAdjacentElement('beforebegin', control);

      // Reflect external select changes (e.g. when our mm-vp picker drives kaching)
      select.addEventListener('change', function() {
        refresh();
        // Catch-all: any time the select's value changes (including programmatic
        // updates by kaching itself), sync the main gallery if this is a color
        // option. Direct chip clicks also fire this via dispatchEvent, so the
        // gallery swap is uniformly triggered from one place.
        syncGalleryToOption(name, select.value);
      });
    }

    function refreshAllChipRows() {
      document.querySelectorAll('select.kaching-bundles__bar-variant-select.mm-kw-select--enhanced').forEach(function(sel) {
        if (typeof sel._mmKwRebuild === 'function') sel._mmKwRebuild();
      });
    }

    function enhanceAllKaching() {
      document.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(enhanceSelect);
      hideUnavailableKachingSwatches();
    }

    // Value-availability lookup shared by every variant UI: a value is "available"
    // when at least one variant carrying that value is in stock. Cached on first
    // call — Shopify variant availability doesn't change for the lifetime of a
    // page load.
    var mmAvailableValuesCache = null;
    function getMmAvailableValues() {
      if (mmAvailableValuesCache) return mmAvailableValuesCache;
      mmAvailableValuesCache = {};
      var variants = getMmVariants();
      for (var i = 0; i < variants.length; i++) {
        if (!variants[i].available) continue;
        var ops = (variants[i].options && variants[i].options.length)
          ? variants[i].options
          : [variants[i].option1, variants[i].option2, variants[i].option3];
        for (var j = 0; j < ops.length; j++) {
          if (ops[j]) mmAvailableValuesCache[ops[j]] = true;
        }
      }
      return mmAvailableValuesCache;
    }
    function mmValueIsAvailable(value) {
      if (value == null || value === '') return true;
      var variants = getMmVariants();
      if (!variants.length) return true; // no JSON ⇒ don't filter anything
      return !!getMmAvailableValues()[value];
    }

    // Kaching renders the Design picker as native <button> swatches (separate
    // from the <select> we enhance). Hide any button whose value has no in-stock
    // variant. Re-run after Kaching re-renders.
    function hideUnavailableKachingSwatches() {
      document.querySelectorAll('.kaching-bundles__swatch-buttons__button').forEach(function(btn) {
        var value = getKachingSwatchValue(btn);
        if (!value) return;
        if (mmValueIsAvailable(value)) {
          btn.style.removeProperty('display');
          btn.removeAttribute('aria-hidden');
        } else {
          btn.style.display = 'none';
          btn.setAttribute('aria-hidden', 'true');
        }
      });
    }

    // ── Multi-pair progressive disclosure ────────────────────────────────
    // When a bundle has >1 pair (e.g. "2 Bubbas Bundle" rendering 3 items),
    // we show pair 1 active, pairs 2..N locked. Clicking any chip in pair N
    // unlocks pair N+1. Size Guide link is hidden on all pairs except the
    // first to avoid duplication.
    function unlockNextPair(currentPair) {
      var wrapper = currentPair.parentElement;
      if (!wrapper) return;
      var pairs = wrapper.querySelectorAll(':scope > .kaching-bundles__bar-variant, :scope > .mm-kw-pair');
      if (!pairs.length) return;
      var idx = Array.prototype.indexOf.call(pairs, currentPair);
      var next = pairs[idx + 1];
      if (!next) return;
      next.classList.remove('is-locked');
      next.classList.add('is-active');
      next.classList.remove('is-pending');
    }

    function setupPairProgression() {
      var wrappers = document.querySelectorAll('kaching-bundle .kaching-bundles__bar-variant-selector-wrapper, kaching-bundles-block .kaching-bundles__bar-variant-selector-wrapper');
      wrappers.forEach(function(wrapper) {
        var pairs = Array.prototype.filter.call(
          wrapper.children,
          function(el) { return el.classList.contains('kaching-bundles__bar-variant'); }
        );
        if (pairs.length < 2) {
          // Single pair — no progression needed; ensure it's active
          pairs.forEach(function(p) { p.classList.add('mm-kw-pair', 'is-active'); });
          return;
        }
        if (wrapper.dataset.mmKwProgression === '1') {
          // Already set up; just sync labels in case pairs were re-rendered
          pairs.forEach(function(p, idx) {
            var hdr = p.querySelector('.mm-kw-pair-header-text');
            if (hdr) hdr.textContent = 'Pair ' + (idx + 1) + ' of ' + pairs.length;
          });
          return;
        }
        wrapper.dataset.mmKwProgression = '1';
        wrapper.classList.add('mm-kw-pairs');

        pairs.forEach(function(pair, idx) {
          pair.classList.add('mm-kw-pair');
          pair.dataset.mmKwPairIndex = String(idx);

          // Inject header "Pair X of N" at the top of each pair
          if (!pair.querySelector('.mm-kw-pair-header')) {
            var header = document.createElement('div');
            header.className = 'mm-kw-pair-header';
            header.innerHTML =
              '<span class="mm-kw-pair-step" aria-hidden="true">' + (idx + 1) + '</span>' +
              '<span class="mm-kw-pair-header-text">Pair ' + (idx + 1) + ' of ' + pairs.length + '</span>' +
              '<span class="mm-kw-pair-lock" aria-hidden="true">Pick pair ' + idx + ' first</span>';
            pair.insertBefore(header, pair.firstChild);
          }

          if (idx === 0) {
            pair.classList.add('is-active');
          } else {
            pair.classList.add('is-locked');
          }
        });
      });
    }

    // ── Convert kaching's image badges into clean text pills ───────────
    // "MOST POPULAR" can render as a decorative <img> with sparkles. We hide
    // the image via CSS and inject a small text pill in its place, using the
    // image's alt/title as the label.
    function isProductImage(img) {
      return img.classList.contains('kaching-bundles__bar-image') ||
             img.classList.contains('kaching-bundles__free-gift__image') ||
             img.classList.contains('kaching-bundles__free-gift-image');
    }
    function looksLikeBadgeContainer(el) {
      if (!el) return false;
      var cls = el.className || '';
      return /badge|highlight|popular|best|most/i.test(cls);
    }
    function fixKachingBadges() {
      document.querySelectorAll('kaching-bundle .kaching-bundles__bar, kaching-bundles-block .kaching-bundles__bar').forEach(function(bar) {
        // Replace decorative <img> badges with text pills (use alt as label)
        bar.querySelectorAll('img').forEach(function(img) {
          if (isProductImage(img)) return;
          if (img.dataset.mmKwBadgeReplaced === '1') return;
          var container = img.parentElement;
          if (!looksLikeBadgeContainer(container) && !looksLikeBadgeContainer(container && container.parentElement)) {
            // Not in a badge-ish container — skip (avoid clobbering misc imgs)
            return;
          }
          img.dataset.mmKwBadgeReplaced = '1';
          var label = (img.getAttribute('alt') || img.getAttribute('title') || img.getAttribute('aria-label') || '').trim();
          // Always hide the decorative image — even if no label, the sparkly
          // graphic was clutter that conflicts with the buybox's clean look.
          img.style.display = 'none';
          if (label && !bar.querySelector('.mm-kw-badge--corner')) {
            var pill = document.createElement('span');
            pill.className = 'mm-kw-badge--corner';
            pill.textContent = label.toUpperCase();
            // Pin to the bar itself (so positioning is consistent)
            bar.appendChild(pill);
          }
        });
        // If kaching renders the badge as text in a container with weird sizing,
        // normalize: any element whose class hints "popular/highlight" gets the
        // corner-pill treatment (already covered by CSS).
      });
    }

    // Pin explicit corner badges to the 2nd and 3rd bundle bars regardless of
    // what Kaching renders. Index 1 → MOST POPULAR, Index 2 → BEST SELLER.
    var MM_KW_EXPLICIT_BADGES = [
      null,
      { text: 'MOST POPULAR', variant: 'popular' },
      { text: 'BEST SELLER',  variant: 'bestseller' }
    ];
    function addBundleBadges() {
      var bars = document.querySelectorAll('kaching-bundle .kaching-bundles__bar, kaching-bundles-block .kaching-bundles__bar');
      bars.forEach(function(bar, i) {
        var cfg = MM_KW_EXPLICIT_BADGES[i];
        if (!cfg) return;
        var existing = bar.querySelector('.mm-kw-badge--corner');
        if (existing && existing.dataset.mmKwExplicit === cfg.variant) return;
        if (existing) existing.remove();
        var pill = document.createElement('span');
        pill.className = 'mm-kw-badge--corner mm-kw-badge--' + cfg.variant;
        pill.dataset.mmKwExplicit = cfg.variant;
        pill.textContent = cfg.text;
        bar.appendChild(pill);
      });
    }

    fixKachingBadges();
    addBundleBadges();

    enhanceAllKaching();
    setupPairProgression();

    // ── Bundle ATC interceptor ─────────────────────────────────────────────
    // Kaching adds the default variant with pair selections as line-item
    // properties — we want each selected pair to become its own line item
    // using the matching real variant. We intercept the ATC button click at
    // the CAPTURE phase (before Kaching/form submit handlers fire), resolve
    // each pair's (option1, option2, …) to a variant id, POST /cart/add.js
    // with all items, then open the cart drawer.
    (function() {
      var form = document.querySelector('[data-mm-product-form]');
      if (!form) return;
      var atcBtn = form.querySelector('[data-mm-action="add-to-cart"]');
      if (!atcBtn) return;
      var variantsScript = document.querySelector('[data-mm-variants-json]');
      var namesScript = document.querySelector('[data-mm-product-option-names]');
      if (!variantsScript || !namesScript) return;

      var variants = [];
      var optionNames = [];
      try { variants = JSON.parse(variantsScript.textContent) || []; } catch (e) {}
      try { optionNames = JSON.parse(namesScript.textContent) || []; } catch (e) {}
      if (!variants.length || !optionNames.length) return;

      function findVariantId(selectionByName) {
        // Strict match: option-name → option position
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < optionNames.length; j++) {
            var wanted = selectionByName[optionNames[j]];
            if (wanted == null) { match = false; break; }
            if (v['option' + (j + 1)] !== wanted) { match = false; break; }
          }
          if (match) return v.id;
        }
        // Fallback: any-position match (Kaching may label selects with
        // different casing/aliases than the product option names).
        var values = Object.keys(selectionByName)
          .map(function(k) { return selectionByName[k]; })
          .filter(function(x) { return x != null && x !== ''; });
        if (!values.length) return null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var opts = [v.option1, v.option2, v.option3].filter(function(x) { return x != null; });
          var ok = values.every(function(val) { return opts.indexOf(val) >= 0; });
          if (ok) return v.id;
        }
        return null;
      }

      function collectKachingPairs() {
        var selected = document.querySelector('.kaching-bundles__bar--selected');
        if (!selected) return null;
        var pairNodes = selected.querySelectorAll('.kaching-bundles__bar-variant');
        if (!pairNodes.length) return null;
        var items = [];
        for (var i = 0; i < pairNodes.length; i++) {
          var sel = {};
          var selects = pairNodes[i].querySelectorAll('select.kaching-bundles__bar-variant-select');
          for (var j = 0; j < selects.length; j++) {
            var n = selects[j].getAttribute('data-name');
            if (n) sel[n] = selects[j].value;
          }
          var vid = findVariantId(sel);
          if (!vid) return null;
          items.push({ id: vid, quantity: 1 });
        }
        return items;
      }

      function openCartDrawer() {
        // Reuse the existing cart-icon handler (CartState.fetch + openCart)
        // by synthesizing a click on any element with data-mm-action="open-cart".
        var opener = document.querySelector('[data-mm-action="open-cart"]');
        if (opener) {
          opener.click();
        } else {
          document.dispatchEvent(new CustomEvent('mm:cart:updated'));
        }
      }

      atcBtn.addEventListener('click', function(e) {
        var items = collectKachingPairs();
        if (!items || items.length < 2) return; // single-item flow stays native
        e.preventDefault();
        e.stopImmediatePropagation();

        var labelEl = atcBtn.querySelector('.mm-buybox__atc-prefix');
        var origLabel = labelEl ? labelEl.textContent : '';
        atcBtn.disabled = true;
        if (labelEl) labelEl.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('cart-add-failed');
          return r.json();
        })
        .then(function() {
          atcBtn.disabled = false;
          if (labelEl) labelEl.textContent = origLabel;
          openCartDrawer();
        })
        .catch(function() {
          atcBtn.disabled = false;
          if (labelEl) labelEl.textContent = origLabel;
        });
      }, true); // capture phase — beats Kaching and form submit
    })();

    // Watch every kaching variant select for value changes — whoever flips it
    // (kaching's native swatch UI, our chip row, or kaching programmatically)
    // triggers a gallery swap. Kaching doesn't reliably dispatch change events
    // when its own swatches are clicked, so polling is the safe net.
    function pollKachingSelects() {
      document.querySelectorAll('select.kaching-bundles__bar-variant-select').forEach(function(sel) {
        var name = sel.getAttribute('data-name') || sel.getAttribute('aria-label') || '';
        var prev = sel.dataset.mmLastValue;
        if (prev === sel.value) return;
        sel.dataset.mmLastValue = sel.value;
        if (prev !== undefined) syncGalleryToOption(name, sel.value);
      });
    }
    // Poll only while a Kaching bundle bar is actually present; if none shows
    // up within ~12s (e.g. the Offer Stack PDP has no Kaching), stop the timer
    // so it doesn't spin forever in the background.
    var kpMisses = 0;
    var kpTimer = setInterval(function() {
      if (document.querySelector('select.kaching-bundles__bar-variant-select')) {
        kpMisses = 0;
        pollKachingSelects();
      } else if (++kpMisses > 60) {
        clearInterval(kpTimer);
      }
    }, 200);
    pollKachingSelects();

    // Kaching renders the Design picker as buttons (.kaching-bundles__swatch-
    // buttons__button), NOT a <select>, so the select-polling above never sees
    // them. Delegate clicks on those buttons and read the chosen value from
    // whichever attribute kaching uses. Tries several fallbacks because the
    // exact attribute varies between widget versions.
    function getKachingSwatchValue(btn) {
      var swatch = btn.querySelector('.kaching-bundles__swatch') || btn;
      return btn.dataset.value
          || btn.dataset.optionValue
          || btn.getAttribute('aria-label')
          || btn.getAttribute('title')
          || swatch.getAttribute('aria-label')
          || swatch.getAttribute('title')
          || swatch.dataset.value
          || (btn.querySelector('.kaching-bundles-option-value') && btn.querySelector('.kaching-bundles-option-value').textContent.trim())
          || btn.textContent.trim()
          || '';
    }
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('.kaching-bundles__swatch-buttons__button');
      if (!btn) return;
      var value = getKachingSwatchValue(btn);
      if (!value) return;
      // The option name isn't on the button — pass a generic non-size label so
      // syncGalleryToOption's size guard doesn't filter it out.
      syncGalleryToOption('Design', value);
    }, true);
    // Kaching hydrates after our script runs; re-scan periodically + on DOM
    // changes to catch newly rendered bundle bars and option changes.
    var kwTries = 0;
    var kwTimer = setInterval(function() {
      var hasKaching = document.querySelector('kaching-bundle, kaching-bundles-block, select.kaching-bundles__bar-variant-select, .kaching-bundles__swatch-buttons__button');
      if (hasKaching) {
        enhanceAllKaching();
        setupPairProgression();
        fixKachingBadges();
        addBundleBadges();
      }
      // Stop after the hydration window — or sooner if Kaching never appears.
      if (++kwTries > 20 || (!hasKaching && kwTries > 8)) clearInterval(kwTimer);
    }, 300);

    // Only observe an actual Kaching host (scoped). Without one (e.g. the Offer
    // Stack PDP) we skip the observer entirely instead of watching all of <body>.
    var kwHost = document.querySelector('kaching-bundle, kaching-bundles-block');
    var kwObserver = kwHost && new MutationObserver(function(mutations) {
      var run = false;
      for (var i = 0; i < mutations.length; i++) {
        var m = mutations[i];
        for (var j = 0; j < m.addedNodes.length; j++) {
          var n = m.addedNodes[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && n.matches('select.kaching-bundles__bar-variant-select')) { run = true; break; }
          if (n.querySelector && n.querySelector('select.kaching-bundles__bar-variant-select')) { run = true; break; }
          if (n.matches && n.matches('.kaching-bundles__swatch-buttons__button')) { run = true; break; }
          if (n.querySelector && n.querySelector('.kaching-bundles__swatch-buttons__button')) { run = true; break; }
          if (n.tagName === 'IMG' || (n.querySelector && n.querySelector('img'))) { run = true; break; }
        }
        if (run) break;
      }
      if (run) {
        enhanceAllKaching();
        setupPairProgression();
        fixKachingBadges();
        addBundleBadges();
      }
    });
    if (kwObserver) kwObserver.observe(kwHost, { childList: true, subtree: true });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-offer-stack"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var root = document.querySelector('[data-mm-os]');
    if (!root) return;

    var swatchMap = {};
    var variantLookup = {};
    try { swatchMap = JSON.parse(root.querySelector('[data-mm-os-swatch-map]').textContent || '{}'); } catch (e) {}
    try { variantLookup = JSON.parse(root.querySelector('[data-mm-os-variant-lookup]').textContent || '{}'); } catch (e) {}

    var designOptName = root.getAttribute('data-design-option-name') || '';
    var sizeOptName = root.getAttribute('data-size-option-name') || '';
    var designIdx = parseInt(root.getAttribute('data-design-idx'), 10);
    var sizeIdx = parseInt(root.getAttribute('data-size-idx'), 10);

    // Paint swatch backgrounds from the variant featured-image map.
    root.querySelectorAll('.mm-os__swatch').forEach(function(sw) {
      var v = sw.getAttribute('data-value');
      var url = swatchMap[v];
      if (url) sw.style.backgroundImage = "url('" + url + "')";
    });

    // Select a tier (radio behavior).
    function selectTier(tierEl) {
      root.querySelectorAll('.mm-os__tier').forEach(function(t) {
        var on = t === tierEl;
        t.classList.toggle('is-selected', on);
        var input = t.querySelector('[data-mm-os-tier-input]');
        if (input) input.checked = on;
      });
    }

    root.querySelectorAll('.mm-os__tier').forEach(function(tierEl) {
      // Click the head (or radio) to select. Clicking inside the body (pickers)
      // shouldn't reselect — the body interactions handle their own state.
      var head = tierEl.querySelector('.mm-os__tier-head');
      if (head) head.addEventListener('click', function(e) {
        // Let the radio's native click do its thing if that's the target
        selectTier(tierEl);
      });
    });

    // Pair pick handlers (design + size).
    function unlockNextPair(currentPair) {
      var tier = currentPair.closest('.mm-os__tier');
      if (!tier) return;
      var pairs = tier.querySelectorAll('.mm-os__pair');
      var idx = Array.prototype.indexOf.call(pairs, currentPair);
      var next = pairs[idx + 1];
      if (next) next.classList.remove('is-locked');
    }

    root.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-mm-os-pick]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var kind = btn.getAttribute('data-mm-os-pick');
      var value = btn.getAttribute('data-value');
      var pair = btn.closest('.mm-os__pair');
      if (!pair) return;

      pair.querySelectorAll('[data-mm-os-pick="' + kind + '"]').forEach(function(s) {
        var on = s === btn;
        s.classList.toggle('is-selected', on);
        s.setAttribute('aria-pressed', on ? 'true' : 'false');
      });

      var label = pair.querySelector('[data-mm-os-value="' + kind + '"]');
      if (label) label.textContent = value;

      // Track the chosen value on the pair for the ATC.
      pair.setAttribute('data-pick-' + kind, value);

      // For design picks on the active selected tier, also drive the main
      // product gallery via the existing sync hook from pdp-hero.
      if (kind === 'design' && typeof window.__mmSyncGalleryToOption === 'function') {
        window.__mmSyncGalleryToOption(designOptName || 'Design', value);
      }

      if (!pair.dataset.touched) {
        pair.dataset.touched = '1';
        unlockNextPair(pair);
      }
    });

    // Size guide
    root.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-mm-os-size-guide]');
      if (!btn) return;
      e.preventDefault();
      var dlg = document.querySelector('[data-mm-sizing]');
      if (!dlg) return;
      if (typeof dlg.showModal === 'function') {
        if (!dlg.open) dlg.showModal();
      } else {
        dlg.setAttribute('open', '');
      }
    });

    // Build the variant id for a (design, size) pick.
    function resolveVariantId(design, size) {
      // The lookup key is option1|option2|option3 in product order. Slot our
      // chosen design/size into the right positions; the third slot (if any)
      // is whatever defaults the product has on its first variant.
      var slots = ['', '', ''];
      // Default unspecified slots to the first variant's options so the key matches.
      var keys = Object.keys(variantLookup);
      if (keys.length) {
        var firstKey = keys[0];
        var firstParts = firstKey.split('|');
        for (var i = 0; i < 3; i++) slots[i] = firstParts[i] || '';
      }
      if (designIdx >= 0) slots[designIdx] = design || slots[designIdx];
      if (sizeIdx >= 0) slots[sizeIdx] = size || slots[sizeIdx];
      var key = slots.join('|');
      return variantLookup[key] || null;
    }

    // ATC
    var atc = root.querySelector('[data-mm-os-atc]');
    if (atc) {
      atc.addEventListener('click', function() {
        var tier = root.querySelector('.mm-os__tier.is-selected');
        if (!tier) return;
        var tierVariantId = tier.getAttribute('data-variant-id');
        var tierName = tier.getAttribute('data-tier-name') || '';
        var tierQty = parseInt(tier.getAttribute('data-tier-qty'), 10) || 1;
        if (!tierVariantId) return;

        // Gather per-pair selections for line item properties.
        var props = { '_bundle': tierName };
        var pairs = tier.querySelectorAll('.mm-os__pair');
        pairs.forEach(function(pair, i) {
          var design = pair.getAttribute('data-pick-design') || pair.getAttribute('data-default-design') || '';
          var size = pair.getAttribute('data-pick-size') || pair.getAttribute('data-default-size') || '';
          var n = i + 1;
          if (design) props['Pair ' + n + ' ' + (designOptName || 'Design')] = design;
          if (size) props['Pair ' + n + ' Size'] = size;
        });

        atc.disabled = true;
        var origLabel = atc.querySelector('.mm-os__atc-label').textContent;
        atc.querySelector('.mm-os__atc-label').textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            items: [{
              id: parseInt(tierVariantId, 10),
              quantity: 1,
              properties: props
            }]
          })
        })
        .then(function(r) {
          if (!r.ok) throw new Error('cart-add-failed');
          return r.json();
        })
        .then(function() {
          document.dispatchEvent(new CustomEvent('mm:cart:updated'));
          atc.querySelector('.mm-os__atc-label').textContent = '✓ Added';
          setTimeout(function() { window.location.href = '/cart'; }, 400);
        })
        .catch(function() {
          atc.disabled = false;
          atc.querySelector('.mm-os__atc-label').textContent = origLabel;
        });
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-see-it-in-action"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var BTN_BOUND_ATTR  = 'data-mm-sia-bound';
    var CLOSE_BOUND_ATTR = 'data-mm-sia-close-bound';
    var ESC_BOUND = false;

    // ── Move "in-hero" / "next-to-title" buttons to their anchor (idempotent) ──
    function relocateButtons() {
      var hero = document.getElementById('mm-main-gallery');
      document.querySelectorAll('[data-mm-sia-anchor="in-hero"]').forEach(function(btn) {
        if (hero && !hero.contains(btn)) hero.appendChild(btn);
      });
      document.querySelectorAll('[data-mm-sia-anchor="next-to-title"]').forEach(function(btn) {
        var title = document.querySelector('.mm-buybox__name');
        if (!title) return;
        var wrap = title.parentNode.querySelector('.mm-sia__title-wrap');
        if (!wrap) {
          wrap = document.createElement('div');
          wrap.className = 'mm-sia__title-wrap';
          title.parentNode.insertBefore(wrap, title);
          wrap.appendChild(title);
        }
        if (!wrap.contains(btn)) wrap.appendChild(btn);
      });
    }

    function getModal() { return document.querySelector('[data-mm-sia-modal]'); }

    function openModal() {
      var modal = getModal();
      if (!modal) return;
      modal.dataset.mmSiaLastFocus = '';
      try { modal._lastFocus = document.activeElement; } catch (e) {}
      modal.hidden = false;
      document.body.style.overflow = 'hidden';
      var closeBtn = modal.querySelector('.mm-sia__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      var modal = getModal();
      if (!modal) return;
      modal.hidden = true;
      document.body.style.overflow = '';
      var player = modal.querySelector('[data-mm-sia-player]');
      if (player) {
        var video = player.querySelector('video');
        if (video) { video.pause(); try { video.currentTime = 0; } catch (e) {} }
        var iframe = player.querySelector('iframe');
        if (iframe) {
          var src = iframe.getAttribute('src');
          iframe.setAttribute('src', src);
        }
      }
      if (modal._lastFocus && modal._lastFocus.focus) modal._lastFocus.focus();
    }

    function bindOpeners() {
      document.querySelectorAll('[data-mm-sia-open]').forEach(function(btn) {
        if (btn.getAttribute(BTN_BOUND_ATTR) === '1') return;
        btn.setAttribute(BTN_BOUND_ATTR, '1');
        btn.addEventListener('click', openModal);
      });
    }

    function bindClosers() {
      var modal = getModal();
      if (!modal) return;
      modal.querySelectorAll('[data-mm-sia-close]').forEach(function(el) {
        if (el.getAttribute(CLOSE_BOUND_ATTR) === '1') return;
        el.setAttribute(CLOSE_BOUND_ATTR, '1');
        el.addEventListener('click', closeModal);
      });
    }

    function bindEscape() {
      if (ESC_BOUND) return;
      ESC_BOUND = true;
      document.addEventListener('keydown', function(e) {
        var modal = getModal();
        if (modal && e.key === 'Escape' && !modal.hidden) closeModal();
      });
    }

    function init() {
      relocateButtons();
      bindOpeners();
      bindClosers();
      bindEscape();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    // ── Re-run on Shopify editor section reloads so the button never disappears ──
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:unload', function() {
      // Modal may have been torn down with the section — reset body lock just in case
      document.body.style.overflow = '';
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mm-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-mm-slide]');
      var thumbs = gallery.querySelectorAll('[data-mm-thumb]');
      function show(idx) {
        slides.forEach(function (el) {
          var active = parseInt(el.getAttribute('data-mm-slide'), 10) === idx;
          el.classList.toggle('is-active', active);
          if (active) { el.removeAttribute('aria-hidden'); }
          else { el.setAttribute('aria-hidden', 'true'); }
        });
        thumbs.forEach(function (el) {
          var active = parseInt(el.getAttribute('data-mm-thumb'), 10) === idx;
          el.classList.toggle('is-active', active);
          el.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          show(parseInt(t.getAttribute('data-mm-thumb'), 10));
        });
      });
    });

    document.querySelectorAll('.mm-pdp-default__form').forEach(function (form) {
      var qtyInput = form.querySelector('[data-mm-qty-input]');
      form.querySelectorAll('[data-mm-qty]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var step = parseInt(btn.getAttribute('data-mm-qty'), 10) || 0;
          var next = (parseInt(qtyInput.value, 10) || 1) + step;
          if (next < 1) { next = 1; }
          qtyInput.value = next;
        });
      });

      var variantsScript = form.querySelector('[data-mm-variants]');
      if (!variantsScript) { return; }
      var variants;
      try { variants = JSON.parse(variantsScript.textContent); } catch (e) { return; }

      var idInput = form.querySelector('[data-mm-variant-id]');
      var priceEl = form.parentElement.querySelector('[data-mm-price]');
      var compareEl = form.parentElement.querySelector('[data-mm-compare]');
      var atc = form.querySelector('[data-mm-atc]');
      var atcLabel = form.querySelector('[data-mm-atc-label]');

      function moneyFmt(cents) {
        var format = (window.Shopify && Shopify.money_format) || '${{amount}}';
        var amount = (cents / 100).toFixed(2);
        return format.replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
      }

      function findVariant() {
        var picked = [];
        form.querySelectorAll('[data-mm-option-input]').forEach(function (input) {
          if (input.type === 'radio' && !input.checked) { return; }
          picked[parseInt(input.getAttribute('data-mm-option-input'), 10)] = input.value;
        });
        return variants.find(function (v) {
          return v.options.every(function (val, i) { return val === picked[i]; });
        });
      }

      function update() {
        var v = findVariant();
        if (!v) { return; }
        idInput.value = v.id;
        if (priceEl) { priceEl.textContent = moneyFmt(v.price); }
        if (compareEl) {
          if (v.compare_at_price && v.compare_at_price > v.price) {
            compareEl.textContent = moneyFmt(v.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        form.querySelectorAll('[data-mm-option-display]').forEach(function (el) {
          var i = parseInt(el.getAttribute('data-mm-option-display'), 10);
          el.textContent = v.options[i];
        });
        if (atc && atcLabel) {
          if (v.available) {
            atc.disabled = false;
            atc.removeAttribute('aria-disabled');
            atcLabel.innerHTML = 'Add to Cart — <span data-mm-atc-price>' + moneyFmt(v.price) + '</span>';
          } else {
            atc.disabled = true;
            atc.setAttribute('aria-disabled', 'true');
            atcLabel.textContent = 'Sold Out';
          }
        }
      }

      form.querySelectorAll('[data-mm-option-input]').forEach(function (input) {
        input.addEventListener('change', update);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
